export const ADMIN = 'ADMIN';
export const ACCOUNTING = 'ACCOUNTING';
export const SUPER_USER = 'SUPER_USER';
export const USER_LEVEL_1 = 'USER_LEVEL_1';
export const USER_LEVEL_2 = 'USER_LEVEL_2';
